import React from "react";
import styles from "./Empty.module.sass";

const Construction = ({
	title = "Required services are under construction",
}) => {
	return (
		<div className={styles.container}>
			<div>
				<img src="/images/warning.png" alt="empthy" />
				<div>{title}</div>
			</div>
		</div>
	);
};

export default Construction;
